import router from '../router'

const EntryParamsService = {
  params: {
    codeInsee: '',
    dateConstruction: '',
    travaux: [],
    statutBeneficiaire: '',
    aidesNationales: [],
    pourcentagePerfGlobal: ''
  },
  entries: {},
  entryParamsNames: [
    'code_insee',
    'date_construction',
    'travaux',
    'statut_beneficiaire',
    'aides_nationales',
    'pourcentage_performance_globale',
    'type_logement',
    'nb_personnes_menage',
    'revenu_fiscal_reference'
  ],
  init () {
    this.setEntries()
    this.setParams()
  },
  getParams () {
    return this.params
  },
  setParams () {
    this.params.codeInsee = this.entries.code_insee ? this.entries.code_insee : ''
    this.params.dateConstruction = this.entries.date_construction ? this.entries.date_construction : ''
    this.params.travaux = this.entries.travaux ? this.entries.travaux.split(',') : []
    this.params.statutBeneficiaire = this.entries.statut_beneficiaire ? this.entries.statut_beneficiaire.toUpperCase() : ''
    this.params.aidesNationales = this.entries.aides_nationales ? this.entries.aides_nationales.split(',') : []
    this.params.pourcentagePerfGlobal = this.entries.pourcentage_performance_globale ? this.entries.pourcentage_performance_globale : ''
    this.params.typeLogement = this.entries.type_logement ? this.entries.type_logement : ''
    this.params.nbPersonnesMenage = this.entries.nb_personnes_menage ? this.entries.nb_personnes_menage : ''
    this.params.revenuFiscalReference = this.entries.revenu_fiscal_reference ? this.entries.revenu_fiscal_reference : ''
  },
  setEntries () {
    this.entryParamsNames.forEach(name => {
      if (router.currentRoute.query[name]) {
        this.entries[name] = router.currentRoute.query[name] ? router.currentRoute.query[name] : null
      }
    })
  }
}

export default EntryParamsService
